export const SpeciesConstants = {
  // Route Tokens
  defaultApi: 'Species',

//  APPLICATION: "application",
//  GROUP: "group",
//  OLDER_THAN: "olderThan",
//  ROLES: "roles",

  // Other constants
    UI: {
    ROOT_PATH: 'species',
  }

} as const;
